<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="6.6" width="12" height="9" rx="2.2"/><path d="M10 3.2v3.4M7.6 15.6v1.2M12.4 15.6v1.2M2.6 9.8v2.6M17.4 9.8v2.6"/><path d="M8 10.4h.01M12 10.4h.01M8.2 12.9h3.6"/></svg>
</template>
